module.exports = __webpack_public_path__ + "img/Doelgroep - Dysfagie.17adcf2b.webp";